export default __webpack_public_path__ + "static/media/bookdoc-marketplace-btn.28a9a1c5.png";